import React, { useEffect } from "react";
import { createTheme, MuiThemeProvider } from "@material-ui/core/styles";
import { useDispatch, useSelector } from "react-redux";
import RTL from "../RTL/RTL";
import "Styles/layouts/_design-layout.scss";
import CssBaseline from "@material-ui/core/CssBaseline";
import { SELECTED_PROJECT, SELECTED_UNIT_ID } from "../../Stores/actionTypes";
import { read } from "../../Helpers/LocalStorage";

function DesignLayout(props) {
  const dispatch = useDispatch();
  const { isLoggedIn } = useSelector((state) => ({
    isLoggedIn: state.auth.isLoggedIn,
  }));
  const theme = createTheme({
    direction: read('language_direction'),
  });
  useEffect(() => {
    if (isLoggedIn) {
      dispatch({ type: SELECTED_PROJECT, selectedProject: read("project") });
      dispatch({ type: SELECTED_UNIT_ID, selectedUnitId: read("unitId") });
    }
  }, [isLoggedIn]);

  useEffect(() => {
    const setDisplayNone = () => {
      try {
        const gr = document.getElementsByClassName("grecaptcha-badge");
        if (gr.length > 0) {
          Object.keys(gr).map((i) => {
            gr[i].style.display = "none";
          });
        }
      } catch (err) {
        console.error('[catch error]', err)
      }
    };
    setTimeout(setDisplayNone, 0);
  }, []);

  return (
    <RTL>
      <MuiThemeProvider theme={theme}>
        <div className="designLayout">
          <CssBaseline />
          {props.children}
        </div>
      </MuiThemeProvider>
    </RTL>
  );
}

export default DesignLayout;
